<template>
	<div>
		<b-modal v-model="mostrar_nota_credito" ref="modalGenerarNC" centered header-bg-variant="dark" header-text-variant="light">
		    <template #modal-header=""><h5>{{ getTitulo }}</h5></template>
			<template #default="">
				<div class="alert alert-primary">Seleccione una opción para generar notas de crédito o modificar datos.</div>
				<b-form id="notaCreditoForm">
					<div class="row">
						<div class="col-md-12">
							<b-select size="sm" id="opcion" name="opcion" v-model="opcion" :options="opciones" required></b-select>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Monto de Folio">
								<b-form-input id="monto_folio" name="monto_folio" size="sm" class="text-right" :value="getMontoFolio()" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Total Nota de Crédito">
								<b-form-input id="total_nc" name="total_nc" size="sm" class="text-right" :value="getTotalNC()" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Máximo Nota de Crédito">
								<b-form-input id="maximo_nc" name="maximo_nc" size="sm" class="text-right" :value="maximo_nc" disabled />
							</b-input-group>
						</div>
					</div>
					<p v-if="opcion != null"></p>
					<div v-if="opcion != null" class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Fecha de Emisión">
								<date-picker id="fecha_emision" name="fecha_emision" v-model="fecha_emision"
									:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required>
								</date-picker>
							</b-input-group>
						</div>
					</div>
					<p v-if="opcion == 'parcial'"></p>
					<div v-if="opcion == 'parcial'" class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Monto Neto">
								<b-form-input id="monto_neto" name="monto_neto" size="sm" type="number" class="text-right" :value="monto_neto" />
							</b-input-group>
						</div>
					</div>
					<p v-if="opcion == 'parcial' || opcion == 'modificar'"></p>
					<div v-if="opcion == 'parcial' || opcion == 'modificar'" class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Comentario">
								<b-textarea id="comentario" name="comentario" size="sm" rows="3" style="resize: none" :value="comentario" />
							</b-input-group>
						</div>
					</div>
				</b-form>
				<p></p>
				<b-alert :show="mostrar_alerta" dismissible :variant="variant" class="text-center" @dismissed="mostrar_alerta=false"><h6>{{mensaje}}</h6></b-alert>
			</template>
			<template #modal-footer="">
				<b-button size="sm" variant="success" @click="modificar" :disabled="disabled">Generar</b-button>
				<b-button size="sm" variant="secondary" @click="cerrar">Cerrar</b-button>
			</template>
		</b-modal>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import $ from "jquery"
	import moment from "moment"


	export default {
		name: "GenerarNotaCredito",
		props: {
			documento: Object, // Objeto con la informacion del documento a refacturar
			onCerrar: Function,
		},
		data() {
			return {
				mostrar_nota_credito: true, // Flag que controla si se muestra o no la ventana "Refacturacion"
				opciones: [
					{ value: null, text: "Seleccione una opción" },
					{ value: "total", text: "Nota de Crédito Total" },
					{ value: "parcial", text: "Nota de Crédito Parcial" },
					{ value: "modificar", text: "Modificar" }
				],
				opcion: null,
				monto_folio: 0,
				total_nc: 0,
				maximo_nc: 0,
				fecha_emision: "",
				monto_neto: 0,
				comentario: "",
				mostrar_alerta: false,
				variant: "",
				mensaje: "",
				disabled: false
			}
		},
        created() {

			this.getNCsAsociadas()
			this.monto_folio = this.documento.totalAmount
		},
		computed: {

			getTitulo() {

				return "GENERAR NC O MODIFICAR EL FOLIO: " + this.documento.number 
            },
        },
		methods: {

			getNCs() {

                // Request para la llamada
				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "D0",
					"operacion": "findNCs",
					"data2query": {
						"id_factura": this.documento.factura_id_bsale
					}
				}

				return axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then((response) => {
					return response
				})
			},

			// Obtenemos las Notas de Créditos asociadas al documento
			getNCsAsociadas() {

				this.getNCs().then((response) => {

					if (response.data.datos !== undefined)
						this.ncs = response.data.datos

					Object.keys(this.ncs).forEach(key => {
						this.total_nc += this.ncs[key].NC_monto
					})

					this.maximo_nc = this.monto_folio - this.total_nc

					if (this.total_nc == this.monto_folio)
					{
						this.variant = "danger"
						this.mensaje = "Error Documento Anulado"
						this.mostrar_alerta = true
						this.disabled = true
					}
				})
			},

			getMontoFolio(iva) {

				return Intl.NumberFormat("es-CL").format(this.monto_folio)
			},

			getTotalNC() {

				return Intl.NumberFormat("es-CL").format(this.total_nc)
			},

			// Si se cierra la ventana Generar Factura, se cambia el valor de la variable para que no se muestre,
			// y se avisa al componente padre a traves del evento "evento-cerrar-generar-factura" para que no cree el objeto al refrescar el DOM
			cerrar() {

				this.mostrar_nota_credito = false

				// Llamamos a la funcion callback asociada a la accion de cerrar la ventana
				if (this.onCerrar)
					this.onCerrar(this.mostrar_nota_credito)
			},

			// Se asume que al presionar Refacturar, se cierra la ventana
			modificar() {

				// Guardamos los datos del formulario para validacion
				var form = $("#notaCreditoForm")[0]
				var data = new FormData(form)

				// Flag que controla la validacion
				var seguir = true 

				data.forEach(function(value, key, o) {

					var required = $("#" + key).attr("required")
					if (required != undefined && value == "") {

						$("#" + key).addClass("is-invalid")
						seguir = false
					} else 
						$("#" + key).removeClass("is-invalid")
				})

				if (this.opcion == "parcial")
				{
					var value = $("#monto_neto").val()
					if (value == 0) 
					{
						$("#monto_neto").addClass("is-invalid")
						seguir = false
					}

					if (value > this.maximo_nc)
					{
						$("#monto_neto").addClass("is-invalid")

						this.variant = "danger"
						this.mensaje = "El monto de la Nota de Crédito a generar es mayor que el maximo disponible"
						this.mostrar_alerta = true						
					}
				}

				if (!seguir)
					return

				var f = this.fecha_emision.split("/")
				var fecha_emision = moment(f[2] + "-" + f[1] + "-" + f[0] + "T00:00:00+00:00").format("X")
				var monto = $("#monto_neto").val();
				var comentario = $("#comentario").val();

				var unitValue = 0;
				if (this.opcion == "total")
					unitValue = this.maximo_nc
				else if (this.opcion == "parcial")
					unitValue = parseInt(monto)

				var cambios = {
					"nc_emissionDate": fecha_emision,
					"nc_priceAdjustment": this.opcion == "modificar" ? 0 : 1,
					"nc_unitValue": unitValue,
					"nc_editTexts": this.opcion == "modificar" ? 1 : 0,
					"nc_quantity": 0,
					"nc_motive": this.opcion == "total" ? "Anula documento" : comentario
				}

                // Llamamos a la API 
				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "f1",
					"operacion": "dte_nc",
					"modifications": cambios,
					"doc_original": this.documento
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					this.variant = "success";
					this.mensaje = "Proceso finalizado con éxito"
					this.mostrar_alerta = true
					this.disabled = true

				}).catch(ex => { 

					this.variant = "danger";
					this.mensaje = ex.message
					this.mostrar_alerta = true
				})
			},
		}
	}
</script>
<style scoped>

	.separador {
		margin-bottom: 5px;
	}
</style>